module.exports = __webpack_public_path__ + "static/media/location-restaurant.49a90e46.svg";